export default {
  path: '/stock-mapping',
  component: () => import('@/views/stockMapping/index.vue'),
  children: [
    {
      path: 'manage',
      name: 'StockMappingManage',
      component: () => import('@/views/stockMapping/pages/ManageLocation.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'warehouse_manager',
          'accounting',
          'accounting_manager'
        ]
      }
    },
    {
      path: 'product',
      name: 'StockMappingFindProduct',
      component: () => import('@/views/stockMapping/pages/FindProductLocation.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'warehouse_manager',
          'accounting',
          'accounting_manager'
        ]
      }
    },
    {
      path: 'location-product/:location',
      name: 'StockMappingLocationProduct',
      component: () => import('@/views/stockMapping/pages/LocationProduct.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'warehouse_manager',
          'accounting',
          'accounting_manager'
        ]
      }
    },
    {
      path: 'create-location',
      name: 'StockMappingCreateLocation',
      component: () => import('@/views/stockMapping/pages/CreateLocation.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'warehouse_manager',
          'accounting',
          'accounting_manager'
        ]
      }
    },
    {
      path: 'print-location',
      name: 'StockMappingPrintLocation',
      component: () => import('@/views/stockMapping/pages/PrintLocation.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'warehouse_manager',
          'accounting',
          'accounting_manager'
        ]
      }
    }
  ]
}
